import { render } from "./DynamicForm.vue?vue&type=template&id=36b95221&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"

import "./DynamicForm.vue?vue&type=style&index=0&id=36b95221&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b95221"]])

export default __exports__